
import { PAYMENT_STATUS } from './PaymentStatusEnum';
import { INSURANCE_PERSON_STATUS } from './InsurancePersonStatusEnum';

const Enum = {
  PAYMENT_STATUS,
  INSURANCE_PERSON_STATUS
};

export { Enum };



// WEBPACK FOOTER //
// ./client/app/shared/enum/index.js